import { BodyText } from '@calendly/ui/components/typography';
import { colorTextStandard } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
const styledSectionCss = "smcstf0";
const StyledSection = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(styledSectionCss, props.className)} />;
});
const styledSectionHeaderCss = "s1ayg3ci";
const StyledSectionHeader = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(styledSectionHeaderCss, props.className)} />;
});
const styledSectionHeaderRowCss = "s3p0qpb";
const StyledSectionHeaderRow = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(styledSectionHeaderRowCss, props.className)} />;
});
const styledSectionBodyUsePaddingCss = "sibwotl";
const styledSectionBodyCss = "s1o3dvzy";
const StyledSectionBody = forwardRef((props, ref) => {
  const {
    usePadding,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(styledSectionBodyCss, {
    [styledSectionBodyUsePaddingCss]: usePadding
  }, props.className)} />;
});
export const WidgetContainer = ({
  title,
  subtitle,
  header,
  children,
  noPadding = false
}) => <StyledSection>
    <StyledSectionHeader>
      <StyledSectionHeaderRow>
        <BodyText weight="bold" color={colorTextStandard}>{title}</BodyText>
        {subtitle && <BodyText color="muted" size="medium">{subtitle}</BodyText>}
        {header}
      </StyledSectionHeaderRow>
    </StyledSectionHeader>
    <StyledSectionBody usePadding={!noPadding}>
      {children}
    </StyledSectionBody>
  </StyledSection>;

require("./widget_container.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./widget_container.js");